<template>
    <div class="modal-challenge-requests">
        <svg class="modal-challenge-requests__art-shade--top-left" width="198" height="131" viewBox="0 0 198 131" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-160.109" y="27.447" width="360" height="206" rx="103" transform="rotate(-45 -160.109 27.447)" fill="#1452B5"/></svg>
        <svg class="modal-challenge-requests__art-pattern--top-right" width="147" height="214" viewBox="0 0 147 214" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity=".5" clip-path="url(#prefix__clip0_903_9719)" stroke="#fff" stroke-width=".875"><path d="M9.546 62.474v19.091M19.092 52.928v19.091M19.092 52.928h19.092M28.64 43.38H47.73M47.731 24.288V43.38M47.731 24.288h19.092M66.823 5.196v19.092M66.824 5.196h19.092M76.37-4.35H95.46"/><path opacity=".94" d="M19.092 72.02V91.11M28.638 62.474v19.091M38.184 52.928v19.091M38.185 52.925h19.092M47.731 43.38h19.092M66.823 24.288V43.38M66.824 24.288h19.092M76.37 14.742H95.46M95.462-4.35v19.092M95.461-4.35h19.092"/><path opacity=".87" d="M19.092 91.111h19.092M28.638 81.565H47.73M38.184 72.02h19.092M57.277 52.925v19.092M66.823 43.38V62.47M66.824 43.38h19.092M76.37 33.834H95.46M95.462 14.742v19.092M95.461 14.742h19.092M114.553-4.35v19.092M114.553-4.35h19.092"/><path opacity=".81" d="M28.638 100.657H47.73M47.73 81.565v19.092M47.73 81.565H66.82M57.277 72.017H76.37M66.824 62.471h19.092M85.916 43.38V62.47M95.462 33.834v19.091M105.007 24.288V43.38M105.007 24.288h19.092M124.099 5.196v19.092M133.645-4.35v19.092M143.191-13.896V5.196"/><path opacity=".74" d="M47.73 100.657v19.092M47.73 100.657H66.82M57.275 91.111h19.092M66.824 81.563h19.092M76.37 72.017H95.46M95.462 52.925v19.092M105.007 43.38V62.47M105.007 43.38h19.092M124.099 24.288V43.38M133.645 14.742v19.091M143.191 5.196v19.092M143.191 5.196h19.092"/><path opacity=".68" d="M57.275 110.203v19.092M57.275 110.203h19.092M66.821 100.657h19.092M85.916 81.563v19.092M95.462 72.017V91.11M95.461 72.017h19.092M114.553 52.925v19.092M114.553 52.925h19.092M133.645 33.834v19.091M143.191 24.288V43.38M152.737 14.742v19.091"/><path opacity=".62" d="M57.275 129.295h19.092M66.821 119.749h19.092M85.913 100.657v19.092M85.915 100.655h19.092M95.461 91.11h19.092M105.007 81.563h19.092M124.099 62.471v19.092M133.645 52.925v19.092M143.191 43.38V62.47M143.191 43.38h19.092"/><path opacity=".55" d="M76.367 129.295v19.092M76.367 129.295H95.46M95.459 110.203v19.092M105.007 100.655v19.092M105.007 100.655h19.092M124.099 81.563v19.092M124.099 81.563h19.092M143.191 62.471v19.092M143.191 62.471h19.092"/><path opacity=".49" d="M85.913 138.841v19.092M95.459 129.295v19.092M95.46 129.295h19.091M105.007 119.747h19.092M114.553 110.201h19.092M133.645 91.11V110.2M143.191 81.563v19.092M143.191 81.563h19.092"/><path opacity=".42" d="M95.459 148.387v19.092M105.005 138.841v19.092M114.551 129.295v19.092M114.553 129.293h19.092M124.099 119.747h19.092M133.645 110.201h19.092M152.737 91.11V110.2"/><path opacity=".36" d="M105.005 157.933v19.092M114.551 148.387v19.092M124.097 138.841v19.092M133.645 129.293v19.092M143.191 119.747v19.092M143.191 119.747h19.092"/><path opacity=".29" d="M105.005 177.025h19.092M114.551 167.479h19.092M124.097 157.933h19.092M143.191 138.839v19.092M143.191 138.839h19.092"/><path opacity=".23" d="M124.097 177.025v19.092M133.643 167.479v19.092M133.643 167.479h19.092M143.191 157.931h19.092"/><path opacity=".17" d="M133.643 186.571v19.092M143.189 177.025v19.092M152.735 167.479v19.092"/><path opacity=".1" d="M133.643 205.663h19.092M143.189 196.117h19.092"/></g><defs><clipPath id="prefix__clip0_903_9719"><path fill="#fff" transform="rotate(-45 86.935 36.01)" d="M0 0h355.5v200H0z"/></clipPath></defs></svg>
        <span class="modal-challenge-requests__light--top"></span>
        <div class="modal-challenge-requests__separator">
            <span class="modal-challenge-requests__separator-icon"></span>
            <span class="modal-challenge-requests__separator-text">VS</span>
        </div>
        <div class="modal-challenge-requests__request-list">
            <div class="card-challenge-request-item-modal">
                <div class="wr-card-challenge-request-item-modal__user-img">
                    <img
                        :src="userImageLink1"
                        class="card-challenge-request-item-modal__user-img">
                    <span class="card-challenge-request-item-modal__user-img-shadow"></span>
                </div>
                <span class="card-challenge-request-item-modal__username">{{ username1 }}</span>
                <span class="card-challenge-request-item-modal__stat-win">
                    <span class="card-challenge-request-item-modal__stat-win-text">{{ statWin1 }}</span>
                    <span class="card-challenge-request-item-modal__stat-win-icon"></span>
                </span>
                <span class="card-challenge-request-item-modal__stat-loss">
                    <span class="card-challenge-request-item-modal__stat-loss-icon"></span>
                    <span class="card-challenge-request-item-modal__stat-loss-text">{{ statLoss1 }}</span>
                </span>
            </div>

            <div class="card-challenge-request-item-modal">
                <div class="wr-card-challenge-request-item-modal__user-img">
                    <img
                        :src="userImageLink2"
                        class="card-challenge-request-item-modal__user-img">
                    <span class="card-challenge-request-item-modal__user-img-shadow"></span>
                </div>
                <span class="card-challenge-request-item-modal__username">{{ username2 }}</span>
                <span class="card-challenge-request-item-modal__stat-win">
                    <span class="card-challenge-request-item-modal__stat-win-text">{{ statWin2 }}</span>
                    <span class="card-challenge-request-item-modal__stat-win-icon"></span>
                </span>
                <span class="card-challenge-request-item-modal__stat-loss">
                    <span class="card-challenge-request-item-modal__stat-loss-icon"></span>
                    <span class="card-challenge-request-item-modal__stat-loss-text">{{ statLoss2 }}</span>
                </span>
            </div>
        </div>

        <div
            v-if="showPreloader"
            class="preloader-challenge-requests-modal">
            <span class="preloader-challenge-requests-modal__gif"></span>
            <span class="preloader-challenge-requests-modal__text">Pratik başlıyor...</span>
        </div>

        <div
            v-if="showGuide"
            class="card-challenge-requests-modal-guide">
            <span class="card-challenge-requests-modal-guide__art"></span>
            <h2 class="card-challenge-requests-modal-guide__heading">Meydan Okuma Pratiği</h2>
            <p class="card-challenge-requests-modal-guide__text">Meydan okuma pratiğine girmeye hazır mısın?</p>
        </div>

        <button
            class="btn-challenge-requests-modal-confirm"
            @click="this.$store.state.envDev ? confirmAcceptance() : confirmAcceptanceApi()">
            <span class="wr-btn-challenge-requests-modal-confirm">
                <span class="btn-challenge-requests-modal-confirm__icon"></span>
                <span class="btn-challenge-requests-modal-confirm__text">Evet</span>
            </span>
        </button>

        <button
            class="btn-challenge-requests-modal-cancel"
            @click="$emit('cancelAcceptance')">
            <span class="wr-btn-challenge-requests-modal-cancel">
                <span class="btn-challenge-requests-modal-cancel__icon"></span>
                <span class="btn-challenge-requests-modal-cancel__text">Hayır</span>
            </span>
        </button>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        data(){
            return {
                showPreloader: false,
                allowRequest: true,
            };
        },
        
        computed: {
            showGuide(){
                if(this.showPreloader){
                    return false;
                }
                return true;
            },

            userImageLink1(){
                // return this.$store.state.api.img + this.$store.state.input.challengeRequests.selectedRequest.user1.id + '.jpg';
                return this.$store.state.api.getImage + this.$store.state.input.challengeRequests.selectedRequest.user1.id;
            },

            userImageLink2(){
                // return this.$store.state.api.img + this.$store.state.userSession.id + '.jpg';
                return this.$store.state.api.getImage + this.$store.state.userSession.id;
            },

            username1(){
                return this.$store.state.input.challengeRequests.selectedRequest.user1.username;
            },

            username2(){
                return 'sen';
            },

            statWin1(){
                return this.$store.state.input.challengeRequests.selectedRequest.user1.stats.win;
            },

            statWin2(){
                return this.$store.state.userSession.stats.win;
            },

            statLoss1(){
                return this.$store.state.input.challengeRequests.selectedRequest.user1.stats.loss;
            },

            statLoss2(){
                return this.$store.state.userSession.stats.loss;
            }
        },

        methods: {
            confirmAcceptance(){
                if(this.allowRequest === false){
                    return false;
                }
                
                this.allowRequest = false;
                this.showPreloader = true;

                fetch(this.$store.state.jsonServer.challengeAccept)
                .then(async response => {
                    return response.json();
                })
                .then(challengeData => {
                    this.$store.commit('setChallengeSession', challengeData.challengeSession);
                    this.$store.commit('setChallengePracticeSession', challengeData.challengePracticeSession);
                    this.$store.commit('setChallengeQuestionSet', challengeData.challengeQuestionSet);
                });
            },

            confirmAcceptanceApi(){
                if(this.allowRequest === false){
                    return false;
                }

                this.allowRequest = false;
                this.showPreloader = true;
                let requestBody = {
                    idChallenge: this.$store.state.input.challengeRequests.selectedRequest.id
                };

                fetch(this.$store.state.api.challengeAccept, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: `acceptanceOptions=${JSON.stringify(requestBody)}`
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(challengeData => {
                    this.$store.commit('setChallengeSession', challengeData.challengeSession);
                    this.$store.commit('setChallengePracticeSession', challengeData.challengePracticeSession);
                    this.$store.commit('setChallengeQuestionSet', challengeData.challengeQuestionSet);
                    this.$router.push('/challenge/practice');
                })
                .catch(err => {
                    if(err.code === 'CHALLENGE_ACCEPT_MODEL/ACCEPT::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeAccept.${err.code}`),
                            didClose: () => {
                                this.$router.push('/login');
                            }
                        });
                        return true;
                    }
                    this.$foneturkError({
                        text: this.$t(`error.default`)
                    });
                });
            }
        },

        mounted(){
            document.body.style = 'overflow: hidden;';
        },

        beforeUnmount(){
            document.body.style = '';
        },
    };
</script>

<style scoped src="@/css/components/modal-challenge-requests.css"></style>